import React, { Component } from "react";
import $ from "jquery";
import "jqueryui";
//import Draggable from "react-draggable";

//import { MdClose } from "react-icons/md";

import "./css/sisModal.scss";

class SisModal extends Component {
	constructor(props) {
		super(props);

		this.refClose = React.createRef();
		this.dragWrap = React.createRef();
		this.background = React.createRef();

		this.state = {
			contents: "",
		};
	}

	close = (evt) => {
		$(this.refClose.current).hide();
		$(this.background.current).hide();

		$(this.refClose.current).attr("style", "");

		if (this.props.closeEvent) {
			this.props.closeEvent();
		}
	};

	show = () => {
		$(".sisModalWrap").hide();
		$(this.refClose.current).show();
		$(this.background.current).show();
	};

	setContents = (contents) => {
		this.setState({
			contents,
		});
	};

	componentDidUpdate() {
		// $(this.refClose.current).show();
	}

	componentDidMount() {
		if (this.props.draggable) {
			$("#" + this.props.id).draggable({
				cancel: ".modalBody, .close",
				containment: "body",
			});
		}
	}

	render() {
		return (
			<>
				<div id={this.props.id} className={`${this.props.className} sisModalWrap`} style={this.props.style} ref={this.refClose}>
					<div className="modalHeader" ref={this.dragWrap}>
						<div className="title">{this.props.title}</div>
						<div className="close" onClick={this.close}>
							{/*<MdClose size="30px" />*/}
						</div>
					</div>
					<div className="modalBody">{this.state.contents ? this.state.contents : this.props.contents}</div>
				</div>
				{this.props.background ? <div ref={this.background} className="background"></div> : ""}
			</>
		);
	}
}

export default SisModal;
